export default __webpack_public_path__ + "260739b1998b8a27698054348a98773a.png";